export enum UserAccountType {
    Administrator = 'administrator',
    Tenant = 'tenant',
    Customer = 'customer',
    Vendor = 'vendor',
    Carrier = 'carrier',
}
